import { render, staticRenderFns } from "./CaseForm.vue?vue&type=template&id=4ba98f5d&scoped=true&"
import script from "./CaseForm.vue?vue&type=script&lang=js&"
export * from "./CaseForm.vue?vue&type=script&lang=js&"
import style0 from "./CaseForm.vue?vue&type=style&index=0&id=4ba98f5d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba98f5d",
  null
  
)

export default component.exports